import { TableCell, Typography } from '@mui/material';
import { omit } from 'ramda';
import { RouteEnum } from 'App';
import { IExam } from '@shared';
import { ViewLink } from '.';

type TypeProps = {
  item: IExam;
  partners?: { label: string; id: string }[];
  isMultiplePartners: boolean;
  pathname: string;
  closeModal: () => void;
};

export function ExamCell({ item, partners, isMultiplePartners, pathname, closeModal }: TypeProps) {
  const { partnerUuid, courseUuid, examUuid, ...rest } = omit(['uuid'], item);
  const to = `${RouteEnum.Partners}/${partnerUuid}/courses/${courseUuid}/exams/${examUuid}`;
  const onClose = pathname === to ? closeModal : () => null;

  return (
    <>
      {isMultiplePartners && partners && (
        <TableCell size='small'>
          <Typography component='span' variant='tableCell'>
            {partners.find(({ id }) => id === partnerUuid)?.label}
          </Typography>
        </TableCell>
      )}
      {Object.values(rest).map((i, index) => (
        <TableCell size='small' key={index}>
          <Typography component='span' variant='tableCell'>
            {i as string}
          </Typography>
        </TableCell>
      ))}
      <ViewLink to={to} onClick={onClose} />
    </>
  );
}
